import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { RefreshCw } from "lucide-react";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div
        className="min-h-screen bg-cream flex items-center justify-center"
        data-testid="auth-loading"
      >
        <RefreshCw className="animate-spin text-charcoal/40" size={24} />
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};
